import { FETCH_ALL_ORPHAN_SLIDERS } from '../constants/actionTypes'

export default (orphanSliders = [], action) => {
    switch (action.type) {
        case FETCH_ALL_ORPHAN_SLIDERS:
            return action.payload;
        default:
            return orphanSliders;
    }
}